










































import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { IcoachCategorySkill, IcoachSkill } from '@/interfaces/IcoachInterfaces'
import { IcoachData } from '@/interfaces/LocalStorageInterfaces'
import Progress from '@/components/common/progressBar/Progress.vue'
import { Getter } from 'vuex-class'

@Component({
  name: 'IcoachSkillList',
  components: {
    Progress
  }
})
export default class IcoachSkillList extends Vue {
  @Getter('icoach/getIcoachSkillMenu')
  icoachCategoryInfo!: IcoachCategorySkill[]
  @Getter('icoach/getIcoachSkill')
  icoachSkillInfo!: IcoachSkill

  @Prop({ required: true })
  icoachUserData!: IcoachData
  @Prop({ required: true })
  stepId!: number

  isCollapsed: boolean = true

  @Emit()
  changeStep (index: number) {
    this.$store.commit('icoach/setIcoachSkillStepId', index)

    this.$router.push({
      name: 'icoach.skill',
      params: {
        icoachUserId: this.icoachUserData.icoachUserId.toString(),
        skillId: this.icoachSkillInfo.id.toString(),
        stepId: index.toString()
      }
    })

    return index
  }

  collapse () {
    this.isCollapsed = !this.isCollapsed
  }
}
